export default {"src":"/_next/static/media/icon_withdrawal_instant_or_line.35520ce4.svg","height":4,"width":20,"blurWidth":0,"blurHeight":0};